module.exports = __webpack_public_path__ + "static/img/creation.b6084676.png";